'use strict';

(() => {
  const suffix = /\s*-\s*(?:nog\s+\d+\s+op\s+voorraad|laatste\s+aantallen)\s*$/i;
  const nativeDefaultTitle = 'default title';
  function display(value) { return String(value ?? '').replace(suffix, '').trim(); }
  function normalized(value) { return String(value ?? '').trim().toLowerCase(); }
  function isNativeDefaultVariant(options, title, hasOnlyDefaultVariant) {
    if (hasOnlyDefaultVariant === true) return true;
    if (hasOnlyDefaultVariant === false) return false;
    const values = Array.isArray(options) ? options : [];
    return values.length === 1
      && normalized(values[0]) === nativeDefaultTitle
      && normalized(title) === nativeDefaultTitle;
  }
  function variantOptions(options, title, hasOnlyDefaultVariant) {
    const values = Array.isArray(options) ? options : [];
    if (isNativeDefaultVariant(values, title, hasOnlyDefaultVariant)) return [];
    return values.map(display);
  }
  function variantTitle(value, hasOnlyDefaultVariant) {
    const title = String(value ?? '');
    const options = title.split(' / ');
    return variantOptions(options, title, hasOnlyDefaultVariant).join(' / ');
  }
  const api = { display, isNativeDefaultVariant, variantOptions, variantTitle };
  if (typeof module !== 'undefined') module.exports = api;
  if (typeof window !== 'undefined' && !window.OluvieOptionLabel) window.OluvieOptionLabel = api;
})();
